"use client";

import Image from "next/image";
import SectionBadge from "../Home/components/SectionBadge";
import profileService from "../profile/service";
import { useEffect, useState } from "react";
import { TUser } from "../profile/types";
import { useIsLoggedIn } from "../auth/services";
import { DialogSignin } from "@/components/DialogSignin";

export default function InsuranceHero() {
  const [user, setUser] = useState<TUser | null>(null);
  const [openDialogSignin, setOpenDialogSignin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const isLoggedIn = useIsLoggedIn();

  useEffect(() => {
    const getUser = async () => {
      try {
        setIsLoading(true);
        const user = await profileService.getUser();
        setUser(user);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };

    getUser();
  }, []);

  return (
    <>
      <DialogSignin isOpen={openDialogSignin} onClose={setOpenDialogSignin} />
      <section
        id="hero"
        className="relative bg-white shadow-sm px-4 mb-10 md:mt-[60px]"
      >
        <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-4 md:gap-16">
          <div className="flex justify-center md:justify-end">
            <Image
              src="/image/insurance/hero.png"
              alt="รางวัลศรีกรุง"
              width={1600}
              height={1000}
              className="w-full h-full rounded-lg duration-300"
            />
          </div>
          <div className="max-w-xl">
            <h2 className="text-2xl font-bold leading-tight mb-3">
              รับสมัครนายหน้าประกันชีวิต
            </h2>
            <p className="text-xl font-bold leading-tight mb-3">
              เปิดโอกาสใหม่… สู่ความมั่นคงในอาชีพ กับศรีกรุงประกันชีวิตโบรคเกอร์
            </p>
            <p className="text-xl mb-3 leading-relaxed">
              เราขอเชิญคุณมาเป็นส่วนหนึ่งของทีม "นายหน้าประกันชีวิต" กับ
              ศรีกรุงประกันชีวิตโบรคเกอร์ ไม่ต้องมีประสบการณ์
              เรามีทีมเทรนเนอร์มืออาชีพสอนให้ สมัครสมาชิกศรีกรุงโบรคเกอร์
              ส่งงานได้ทั้ง2ฝั่ง ประกันวินาศภัยและประกันชีวิต (มีใบอนุญาติ)
            </p>
            {isLoading ? (
              <></>
            ) : (
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center md:justify-start">
                <a
                  href="/member-register"
                  className="h-[50px] md:w-[160px] px-8 py-3 bg-[#126d37] text-white rounded-full font-bold hover:bg-[#005825] transition text-lg shadow-md hover:shadow-lg text-center"
                >
                  สมัครสมาชิก
                </a>
                {user == null && !isLoggedIn && (
                  <button
                    type="button"
                    onClick={() => setOpenDialogSignin(true)}
                    className="h-[50px] md:w-[160px] px-8 py-3 border-2 border-[#67b266] bg-[#67b266] text-white rounded-full font-bold hover:bg-[#005825] transition text-lg shadow-md hover:shadow-lg text-center"
                  >
                    เข้าสู่ระบบ
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </section>

      <section id="privilege" className="relative bg-white w-full">
        <SectionBadge
          title="นายหน้าประกันชีวิต  สร้างอิสระให้ชีวิต มีทุกแผนที่คุณต้องการ"
          color="#120a6b"
        />
        <div className="container mx-auto flex flex-col md:flex-row items-center justify-between md:gap-8 md:py-6">
          <img
            src="/image/insurance/hero1.png"
            alt=""
            className="h-full w-full"
          />
        </div>
      </section>
    </>
  );
}
